module.exports = __webpack_public_path__ + "static/img/14000530.3b860899.png";